import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  AuthService,
  ENV_TOKEN,
  EnvironmentService,
  authTokenInterceptor,
  errorConfig,
} from '@vallia-doc-flow/ui-auth';
import { provideToastr } from 'ngx-toastr';
import { ToastrComponent, defaultAvToastrConfig } from '@ng-cds/ui-components/toastr';
import { progressInterceptor } from '@ng-cds/ui-components/api/interceptors';
import { ERROR_CONFIG, errorInterceptor } from '@ng-cds/ui-components/api/interceptors';
import { environment } from '../environments/environment';
import { MarkdownService, provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authTokenInterceptor, errorInterceptor, progressInterceptor])),
    { provide: ENV_TOKEN, useValue: environment },
    provideToastr({
      ...defaultAvToastrConfig,
      toastComponent: ToastrComponent,
    }),
    provideMarkdown(),
    { provide: ERROR_CONFIG, useValue: errorConfig },
    AuthService,
    EnvironmentService,
    MarkdownService,
  ],
};
